import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hawk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errorMessage(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtDate = (s) => (s ? new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");
export const LOGO = "https://customer-assets-jt897jd0.emergentagent.net/job_4db33d9a-31fc-405a-8599-a94a4e62f480/artifacts/1723fb2fe8301da2_Hawksons%20Agricultural%20Emblem.png";
export const BANNER = "https://customer-assets-jt897jd0.emergentagent.net/job_4db33d9a-31fc-405a-8599-a94a4e62f480/artifacts/5af50cc1bc7e1dce_Pure%20Moringa%2C%20Stronger%20Partnerships.png";
export const STATUS_LABELS = { pending: "Pending", paid: "Confirmed", processing: "Processing", shipped: "Shipped", delivered: "Delivered", cancelled: "Cancelled" };
